export const DEFAULT_LINE_COLOR = '#000';
export const DEFAULT_LINE_WIDTH = 1;
